<template>
  <div class="dashboard-container">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader
            style="background-color: #145654"
            class="border-bottom d-flex justify-content-between align-items-center px-3"
          >
            <h4 class="card-title mb-0 text-white d-flex align-items-center">
              <CIcon name="cil-window-restore" size="xl" class="mr-2"/> {{ $t('reportList.pageTitle') }}
            </h4>
            <button class="report-btn" @click="checkBeforeReport">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="12" y1="18" x2="12" y2="12" />
                <line x1="9" y1="15" x2="15" y2="15" />
              </svg>
              <span>{{ $t('reportList.newRequest') }}</span>
            </button>
          </CCardHeader>

          <CCardBody class="p-2 p-md-4">
            <div class="custom-tabs">
              <div class="tabs-scroll-container">
                <div class="tabs-header">
                  <button :class="['tab-item', { active: activeTab === 'report' }]" @click="switchTab('report')">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                  <span style="font-size: 15px; font-weight: 500">{{ $t('reportList.tabActive') }}</span>
                </button>
                  <button :class="['tab-item', { active: activeTab === 'history' }]" @click="switchTab('history')">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                  </svg>
                  <span style="font-size: 15px; font-weight: 500">{{ $t('reportList.tabHistory') }}</span>
                </button>
                </div>
              </div>

              <div class="tabs-content mt-3">
                <div v-show="activeTab === 'report'" class="tab-panel table-responsive-wrapper">
                  <Areportable 
                    ref="areportable"
                    @show-detail="handleShowDetail" 
                    @assign-department="handleAssignDepartment"
                    @refresh="refreshTables"
                  />
                </div>
                <div v-show="activeTab === 'history'" class="tab-panel table-responsive-wrapper">
                  <Ahistorytable ref="ahistorytable" @show-detail="handleShowDetail" />
                </div>
              </div>
            </div>
          </CCardBody>
        </CCard>

        <div id="detail-section" v-if="selectedReport" class="mt-4 mb-5">
          <ReportDetail
            :report="selectedReport"
            @close="closeDetail"
            @refresh="refreshTables"
            @ticket-updated="handleTicketUpdated"
          />
        </div>
      </CCol>
    </CRow>

    <SendReport v-model="sendReportModal" @ticket-created="refreshTables" />
  </div>
</template>

<script>
import Ahistorytable from "../../components/admin/Ahistorytable.vue";
import Areportable from "../../components/admin/Areportable.vue";
import ReportDetail from "./ReportDetail.vue";
import SendReport from "../../components/user/SendReport.vue";
import { getSocket } from "@/service/socketio.service";
import Swal from 'sweetalert2';

export default {
  name: "Dashboard",
  components: {
    Areportable,
    Ahistorytable,
    ReportDetail,
    SendReport,
  },
  mounted() {
    const socket = getSocket();
    if (socket) {
      socket.on("admin_new_ticket", (data) => {
        console.log("New ticket received:", data);
        this.refreshTables();
      });
      socket.on("ticket_updated", (data) => {
        console.log("Ticket updated:", data);
        this.refreshTables();
        if (this.selectedReport && this.selectedReport._id === data._id) {
            if (data.status === 'cancelled') {
              this.selectedReport = null;
              Swal.fire({
                icon: 'info',
                title: this.$t('mainuser.ticketCancelledTitle'),
                text: this.$t('mainuser.ticketCancelledText'),
                confirmButtonColor: '#3085d6',
              });
            } else {
              this.selectedReport = { ...this.selectedReport, ...data };
            }
        }
      });
    }
  },
  beforeDestroy() {
    const socket = getSocket();
    if (socket) {
      socket.off("admin_new_ticket");
      socket.off("ticket_updated");
    }
  },
  data() {
    return {
      activeTab: "report",
      selectedReport: null,
      sendReportModal: false,
      historyLoaded: false,
    };
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
      if (tab === 'history' && !this.historyLoaded) {
        this.historyLoaded = true;
        this.$nextTick(() => {
          if (this.$refs.ahistorytable) {
            this.$refs.ahistorytable.loadHistory();
          }
        });
      }
    },

    handleShowDetail(item) {
      let currentStep = 1;
      const statusMap = { pending: 1, assigned: 2, in_progress: 3, done: 4, welldone: 4 };
      currentStep = statusMap[item.status] || 1;

      this.selectedReport = {
        ...item,
        currentStep,
      };

      this.$nextTick(() => {
        const element = document.getElementById("detail-section");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },

    handleAssignDepartment(item) {
      // Handle assignment mode for "other" category tickets
      this.selectedReport = {
        ...item,
        currentStep: 1,
      };

      this.$nextTick(() => {
        const element = document.getElementById("detail-section");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },

    closeDetail() {
      this.selectedReport = null;
    },

    handleTicketUpdated(updatedTicket) {
      if (this.selectedReport && updatedTicket && this.selectedReport._id === updatedTicket._id) {
        this.selectedReport = { ...this.selectedReport, ...updatedTicket };
      }
    },

    refreshTables() {
      // Refresh only the active table to save network and server resources without collapsing open detail
      if (this.activeTab === 'report' && this.$refs.areportable) {
        this.$refs.areportable.refreshData();
      } else if (this.activeTab === 'history' && this.$refs.ahistorytable) {
        this.$refs.ahistorytable.loadHistory();
      }
    },
    async checkBeforeReport() {
      const userStr = localStorage.getItem('user');
      const userId = userStr ? JSON.parse(userStr)._id : null;
      if (!userId) {
        this.sendReportModal = true;
        return;
      }
      try {
        const response = await fetch(`${process.env.VUE_APP_APP_URL}/ticket/user/${userId}/active`);
        if (response.ok) {
          const data = await response.json();
          if (data.success && Array.isArray(data.data)) {
            const unevaluatedTicket = data.data.find(t => t.status === 'done');
            if (unevaluatedTicket) {
              Swal.fire({
                icon: 'warning',
                title: this.$t('mainuser.evalBeforeNewTitle'),
                text: this.$t('mainuser.evalBeforeNewText'),
                confirmButtonColor: '#2ba9a5',
                confirmButtonText: this.$t('login.ok'),
                returnFocus: false
              }).then(() => {
                this.handleShowDetail(unevaluatedTicket);
              });
              return;
            }
          }
        }
      } catch (err) {
        console.error("Error checking unevaluated tickets", err);
      }
      this.sendReportModal = true;
    }
  },
};
</script>

<style scoped>
.report-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 32px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
  transition: all 0.3s ease;
  animation: pulse-glow 2s ease-in-out infinite;
}

.report-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5);
  animation: none;
}

.report-btn:active {
  transform: translateY(0);
}

.report-btn svg {
  width: 20px;
  height: 20px;
}

@keyframes pulse-glow {
  0%,
  100% {
    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 6px 30px rgba(16, 185, 129, 0.8),
      0 0 50px rgba(16, 185, 129, 0.5);
    transform: scale(1.05);
  }
}

.custom-tabs {
  margin-top: 10px;
  width: 100%;
}

/* Scrollable Tabs Container */
.tabs-scroll-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 5px;
}

.tabs-header {
  display: flex;
  gap: 8px;
  border-bottom: 2px solid #e9ecef;
  margin-bottom: 15px;
  white-space: nowrap;
  min-width: 100%;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  position: relative;
  bottom: -2px;
  font-size: 15px;
  font-weight: 500;
}

.tab-item:hover {
  color: #495057;
  background: #f8f9fa;
}

.tab-item.active {
  color: #000000;
  font-weight: 600;
  border-bottom-color: #2ba9a5;
  background-color: #2ba9a5;
}

/* Responsive Table Wrapper */
.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* =========================================
   📱 Mobile Responsive Styles (< 768px)
   ========================================= */
@media (max-width: 768px) {
  .card-header h4 {
    font-size: 1.1rem;
  }
  
  .tab-item {
    padding: 10px 15px;
    font-size: 14px;
  }

  .tab-item svg {
    width: 16px;
    height: 16px;
  }
  
  .card-body {
    padding: 10px !important;
  }
}
</style>